import type { SafeInsets } from "../hud/slots.ts";

/**
 * The page's safe-area insets in device pixels (`env(safe-area-inset-*)`), read through a probe element that takes them
 * as padding. The page declares `viewport-fit=cover` (ADR-061's amendment of 2026-10-31, decision 4), so it draws under a
 * notch, a rounded corner and the system bars and the insets say how far in the controls must stand: the stick, the buttons
 * and the HUD keep inside them. A display with none, and a desktop, reads zeros.
 *
 * @param doc The document to probe.
 * @param ratio The device pixel ratio.
 * @returns The insets, zeros where the browser has none.
 */
export function readSafeInsets(doc: Document, ratio: number): SafeInsets {
  const probe = doc.createElement("div");
  probe.setAttribute("aria-hidden", "true");
  probe.style.cssText = "position:fixed;left:0;top:0;width:0;height:0;visibility:hidden;pointer-events:none;padding:env(safe-area-inset-top,0px) env(safe-area-inset-right,0px) env(safe-area-inset-bottom,0px) env(safe-area-inset-left,0px)";
  doc.body.append(probe);
  const style = getComputedStyle(probe);
  const px = (value: string): number => Math.max(0, Math.round((Number.parseFloat(value) || 0) * ratio));
  const insets = { top: px(style.paddingTop), right: px(style.paddingRight), bottom: px(style.paddingBottom), left: px(style.paddingLeft) };
  probe.remove();
  return insets;
}
